import { camelizeKeys } from 'humps';
import { clientHttp } from '@/common/http';

export const fetcher = async <T extends object>(url: string): Promise<T> => {
  const json = await clientHttp.get(url).json<T>();
  return camelizeKeys(json) as unknown as T;
};
